import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { useDispatch, useSelector } from 'react-redux';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { setSelectedProcessId, setProcessText, updateChoices } from '@Services/Editor';

import useHover from '@Hooks/useHover';
import Header from './Header';
import Text from './Text';
import Choice from './Choice';
import AddingChoiceButton from './AddingChoiceButton';
import Divider from './Divider';

const Process = ({
  processId,
  text,
  isEventFinish,
  choices,
  processIdsByValidationPassed,
  snackBarRef,
  scrollToTargetProcess,
  setPage,
}) => {
  const dispatch = useDispatch();
  const hilightProcess = useSelector(({ editor }) => editor.hilightProcess);

  const isValidationPassed = processIdsByValidationPassed.includes(processId);

  const onTextChange = useCallback(
    ({ target: { value } }) => {
      if (value.length > 1000) return;
      dispatch(setProcessText({ processId, text: value }));
    },
    [dispatch],
  );

  const handleUpdateSelectedProcessId = useCallback(() => {
    dispatch(setSelectedProcessId({ processId }));
  }, [dispatch, processId]);

  const handleUpdateChoices = useCallback(
    (afterItemIndex, beforeItemIndex) => {
      dispatch(updateChoices({ processId, afterItemIndex, beforeItemIndex }));
    },
    [dispatch],
  );

  const handleOnDragEnd = useCallback(result => {
    if (!result.destination) {
      return;
    }

    const beforeDragItemIndex = result.source.index;
    const afterDragItemIndex = result.destination.index;

    handleUpdateChoices(afterDragItemIndex, beforeDragItemIndex);
  }, []);

  const moreThanFour = choices?.length >= 4;

  const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();

  // const [freshProcess, setFreshProcess] = React.useState(true);

  // console.log('freshProcess:', freshProcess);
  // React.useEffect(() => {
  //   if (freshProcess) {
  //     const timer = setTimeout(() => {
  //       setFreshProcess(false);
  //     }, 500);

  //     return () => clearTimeout(timer);
  //   }
  // }, [freshProcess]);

  const hilightVisibleProcess = hilightProcess?.hilightProcessId === processId && hilightProcess?.highLightVisible;

  return (
    choices && (
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <ProcessWrapper hilightVisible={hilightVisibleProcess}>
          <ProcessContainer id={`page_${processId}`}>
            <Header processId={processId} isValidationPassed={isValidationPassed} snackBarRef={snackBarRef} />
            <Text value={text} onChange={onTextChange} onFocus={handleUpdateSelectedProcessId} />

            <Droppable droppableId={`${processId}:choice`}>
              {provided => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <ChoiceContainer ref={provided.innerRef} {...provided.droppableProps}>
                  {choices?.map(({ text: choiceText, resultSelect, results, choiceId }, index) => (
                    <Choice
                      key={`${processId}:${choiceId}`}
                      index={index}
                      processId={processId}
                      choiceId={choiceId}
                      text={choiceText}
                      resultSelect={resultSelect}
                      results={results}
                      snackBarRef={snackBarRef}
                      isProcessTextEmpty={text.length < 1}
                      validatedProcess={processIdsByValidationPassed}
                    />
                  ))}

                  {provided.placeholder}
                </ChoiceContainer>
              )}
            </Droppable>

            {!isEventFinish && !moreThanFour && <AddingChoiceButton processId={processId} />}
          </ProcessContainer>
          <Divider
            isHovered={isHovered}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            processId={processId}
            scrollToTargetProcess={scrollToTargetProcess}
            setPage={setPage}
            snackBarRef={snackBarRef}
          />
        </ProcessWrapper>
      </DragDropContext>
    )
  );
};

Process.propTypes = {
  processId: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  isEventFinish: PropTypes.bool.isRequired,
  choices: PropTypes.arrayOf(PropTypes.object).isRequired,
  processIdsByValidationPassed: PropTypes.arrayOf(PropTypes.number).isRequired,
};
const ProcessWrapper = styled.div`
  border-radius: 12px;
  padding-right: 8px;
  transition: border 0.5s ease-in-out;
  border: 1px solid transparent; /* 초기 경계선 상태를 투명하게 설정 */

  ${({ hilightVisible }) =>
    hilightVisible &&
    css`
      border: 1px solid #49c8e8;
    `}
`;

const ProcessContainer = styled.section`
  /* padding: 60px 0px 20px 10px; */
  padding: 60px 0px 20px 8px;

  position: relative;
`;

const ChoiceContainer = styled.div``;

export default React.memo(Process);

// import React, { useCallback } from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
// import { useDispatch } from 'react-redux';
// import { DragDropContext, Droppable } from 'react-beautiful-dnd';

// import { setSelectedProcessId, setProcessText, updateChoices } from '@Services/Editor';

// import useHover from '@Hooks/useHover';
// import Header from './Header';
// import Text from './Text';
// import Choice from './Choice';
// import AddingChoiceButton from './AddingChoiceButton';
// import Divider from './Divider';

// const Process = ({
//   processId,
//   text,
//   isEventFinish,
//   choices,
//   processIdsByValidationPassed,
//   snackBarRef,
//   scrollToTargetProcess,
//   setPage,
// }) => {
//   const dispatch = useDispatch();
//   const isValidationPassed = processIdsByValidationPassed.includes(processId);

//   const onTextChange = useCallback(
//     ({ target: { value } }) => {
//       if (value.length > 1000) return;
//       dispatch(setProcessText({ processId, text: value }));
//     },
//     [dispatch],
//   );

//   const handleUpdateSelectedProcessId = useCallback(() => {
//     dispatch(setSelectedProcessId({ processId }));
//   }, [dispatch]);

//   const handleUpdateChoices = useCallback(
//     (afterItemIndex, beforeItemIndex) => {
//       dispatch(updateChoices({ processId, afterItemIndex, beforeItemIndex }));
//     },
//     [dispatch],
//   );

//   const handleOnDragEnd = useCallback(result => {
//     if (!result.destination) {
//       return;
//     }

//     const beforeDragItemIndex = result.source.index;
//     const afterDragItemIndex = result.destination.index;

//     handleUpdateChoices(afterDragItemIndex, beforeDragItemIndex);
//   }, []);

//   const moreThanFour = choices?.length >= 4;

//   const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();

//   // const [freshProcess, setFreshProcess] = React.useState(true);

//   // console.log('freshProcess:', freshProcess);
//   // React.useEffect(() => {
//   //   if (freshProcess) {
//   //     const timer = setTimeout(() => {
//   //       setFreshProcess(false);
//   //     }, 500);

//   //     return () => clearTimeout(timer);
//   //   }
//   // }, [freshProcess]);

//   return (
//     choices && (
//       <DragDropContext onDragEnd={handleOnDragEnd}>
//         <div>
//           <ProcessContainer
//             id={`page_${processId}`}
//             // style={{
//             //   backgroundColor: freshProcess ? 'lavender' : undefined,
//             // }}
//           >
//             <Header processId={processId} isValidationPassed={isValidationPassed} snackBarRef={snackBarRef} />
//             <Text value={text} onChange={onTextChange} onFocus={handleUpdateSelectedProcessId} />

//             <Droppable droppableId={`${processId}:choice`}>
//               {provided => (
//                 // eslint-disable-next-line react/jsx-props-no-spreading
//                 <ChoiceContainer ref={provided.innerRef} {...provided.droppableProps}>
//                   {choices?.map(({ text: choiceText, resultSelect, results, choiceId }, index) => (
//                     <Choice
//                       key={`${processId}:${choiceId}`}
//                       index={index}
//                       processId={processId}
//                       choiceId={choiceId}
//                       text={choiceText}
//                       resultSelect={resultSelect}
//                       results={results}
//                       snackBarRef={snackBarRef}
//                       isProcessTextEmpty={text.length < 1}
//                       validatedProcess={processIdsByValidationPassed}
//                     />
//                   ))}

//                   {provided.placeholder}
//                 </ChoiceContainer>
//               )}
//             </Droppable>

//             {!isEventFinish && !moreThanFour && <AddingChoiceButton processId={processId} />}
//           </ProcessContainer>
//           <Divider
//             isHovered={isHovered}
//             handleMouseEnter={handleMouseEnter}
//             handleMouseLeave={handleMouseLeave}
//             processId={processId}
//             scrollToTargetProcess={scrollToTargetProcess}
//             setPage={setPage}
//           />
//         </div>
//       </DragDropContext>
//     )
//   );
// };

// Process.propTypes = {
//   processId: PropTypes.number.isRequired,
//   text: PropTypes.string.isRequired,
//   isEventFinish: PropTypes.bool.isRequired,
//   choices: PropTypes.arrayOf(PropTypes.object).isRequired,
//   processIdsByValidationPassed: PropTypes.arrayOf(PropTypes.number).isRequired,
// };

// const ProcessContainer = styled.section`
//   padding: 60px 0px 20px 10px;
//   position: relative;
// `;

// const ChoiceContainer = styled.div``;

// export default React.memo(Process);
